import { useEffect, useRef } from 'react';

export default function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in-up');
            entry.target.classList.remove('opacity-0');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const features = [
    { icon: 'ri-subway-line', title: '신상도역 초역세권', desc: '교통 및 여가 녹지 접근성 양호, 중심지 및 양호한 녹지와 연계된 주거지 잠재력이 높은 프리미엄 입지' },
    { icon: 'ri-building-line', title: '상도동 미니신도시', desc: '상도 14\u00b715구역(4,323세대)과 모아타운(1,534세대)으로 약 5,900세대 규모의 대규모 재개발 예정' },
    { icon: 'ri-shield-check-line', title: 'HUG 전세자금대출 80%', desc: '계약금 10%만으로 입주 가능, 10년 거주 후 소유권 이전하는 안정적인 장기일반민간임대주택' },
  ];

  return (
    <section id="about" ref={sectionRef} className="relative w-full py-20 md:py-32 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto text-center">
        <span className="reveal opacity-0 inline-block px-4 py-1.5 mb-8 text-sm font-medium tracking-widest text-foreground-600 border border-foreground-300 rounded-full uppercase">
          APT 신상도역
        </span>
        <h2 className="reveal opacity-0 font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground-900 leading-tight mb-6 text-balance">
          총 459세대
          <br />
          민간임대아파트
        </h2>
        <p className="reveal opacity-0 text-foreground-600 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto mb-16">
          서울 동작구 상도동 신상도역 인근에 들어서는 장기일반민간임대주택으로,
          59㎡ 315세대, 71㎡ 37세대, 84㎡ 107세대 총 459세대의 기업형민간임대형식 프리미엄 주거단지입니다.
          교통미 및 여가 녹지 접근성이 양호하며, 상도 14\u00b715구역과 모아타운 재개발로 약 5,900세대 미니신도시로 탈바꿈될 예정인 잠재력 높은 입지입니다.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
          {features.map((item, i) => (
            <div
              key={item.title}
              className="reveal opacity-0 p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/50 text-center transition-all hover:shadow-md hover:-translate-y-1"
              style={{ animationDelay: `${i * 150}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-base text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}